export const LMS = 'LMS'
export const CONNECTIONS = 'CONNECTIONS'
export const SECURE_PAYMENTS = 'SECURE_PAYMENTS'
export const OTHER = 'OTHER'
